import { DrawGlassDoorA2 } from "$src/CGS/domain/dto/GlassDoor/DrawGlassDoorA2";
import { DrawGlassDoorA27 } from "$src/CGS/domain/dto/GlassDoor/DrawGlassDoorA27";
import { DrawGlassDoorA3 } from "$src/CGS/domain/dto/GlassDoor/DrawGlassDoorA3";
import { DrawGlassDoorA4 } from "$src/CGS/domain/dto/GlassDoor/DrawGlassDoorA4";
import { DrawGlassDoorA6 } from "$src/CGS/domain/dto/GlassDoor/DrawGlassDoorA6";
import { DrawGlassDoorX1 } from "$src/CGS/domain/dto/GlassDoor/DrawGlassDoorX1";
import { DrawGlassDoorX2 } from "$src/CGS/domain/dto/GlassDoor/DrawGlassDoorX2";
import { IDrawGlassDoor } from "$src/CGS/domain/dto/GlassDoor/IDrawGlassDoor";
import LengthValue from "$src/CGS/domain/dto/core/Length/LengthValue";
import { FrontElementMetadata } from "../../Metadata/FrontMetadata";
import { IFrontElementGenerator } from "../IFrontElementGenerator";


export class FrontShapeGeneratorFactory {
    static getGenerator(
        frontElementMetadata: FrontElementMetadata,
        drawGlassDoor: IDrawGlassDoor,
        doorThickness: LengthValue
    ): IFrontElementGenerator | null {

        // switch (drawGlassDoor.constructor) {
        //     case DrawGlassDoorA2:
        //         return new FrontShapeA2Generator(frontElementMetadata, drawGlassDoor as DrawGlassDoorA2, doorThickness);
        //     case DrawGlassDoorA3:
        //         return new FrontShapeA3Generator(frontElementMetadata, drawGlassDoor as DrawGlassDoorA3, doorThickness);
        //     case DrawGlassDoorA4:
        //         return new FrontShapeA4Generator(frontElementMetadata, drawGlassDoor as DrawGlassDoorA4, doorThickness);
        //     case DrawGlassDoorA6:
        //         return new FrontShapeA6Generator(frontElementMetadata, drawGlassDoor as DrawGlassDoorA6, doorThickness);
        //     case DrawGlassDoorA27:
        //         return new FrontShapeA27Generator(frontElementMetadata, drawGlassDoor as DrawGlassDoorA27, doorThickness);
        //     case DrawGlassDoorX1:
        //         return new FrontShapeX1Generator(frontElementMetadata, drawGlassDoor as DrawGlassDoorX1, doorThickness);
        //     case DrawGlassDoorX2:
        //         return new FrontShapeX2Generator(frontElementMetadata, drawGlassDoor as DrawGlassDoorX2, doorThickness);
        //     default:
        //         return null;
        // }

        return null;
    }
}
